import * as React from "react";
import { Link } from "react-router-dom";

import { Search } from "@common/_constants";

interface MessageSummaryProps {
    total: number;
    unread: number;
    jobId: number;
    userId?: number;
    onSendMessage?: (e: any) => void;
}

const MessageSummary: React.SFC<MessageSummaryProps> = (
    props: MessageSummaryProps
) => {
    const { total, unread, jobId, userId, onSendMessage } = props;
    const context_job_id = jobId ? `context_job_id=${jobId}` : "";
    const context_user_id = userId ? `context_user_id=${userId}` : "";

    return (
        <div className="c-block">
            <h2 id="messages" className="c-block__title">
                messages
            </h2>
            <div className="c-block__body">
                {total === 0 && <span>You have no messages.</span>}
                {total > 0 && (
                    <span>
                        You have{" "}
                        <Link
                            className="c-link c-link--magenta"
                            to={`/messages/?${context_job_id}&${context_user_id}`}
                        >
                            {total} message{total !== 1 ? "s" : ""}
                        </Link>
                        {unread > 0 && (
                            <span>
                                , with{" "}
                                <Link
                                    className="c-link c-link--magenta"
                                    to={`/messages/?${context_job_id}&${context_user_id}&filter_type=${Search.MessageFilter.MY_UNREAD_MESSAGES}`}
                                >
                                    {unread} unread
                                </Link>
                            </span>
                        )}
                        .
                    </span>
                )}
            </div>
            {!!onSendMessage && (
                <div className="c-link--send-message">
                    <a
                        className="c-link c-link--magenta"
                        onClick={onSendMessage}
                    >
                        send message
                    </a>
                </div>
            )}
        </div>
    );
};

export default MessageSummary;
